module.exports = __webpack_public_path__ + "static/sophie-bakalar-67210faf06148384f46fd4fb1567ad05.jpg";